import React from "react";
import { Box, Typography } from "@mui/material";

const socialLinks = [
  {
    name: "Facebook",
    desc: "Morris Garages India",
    href: "https://www.facebook.com/MGMotorIN",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="44" height="44">
        <circle cx="12" cy="12" r="11" stroke="#3b5998" strokeWidth="1.5" fill="white"/>
        <path d="M13.5 8.5H15V6.5H13C11.6 6.5 10.5 7.6 10.5 9V10.5H9V12.5H10.5V18H12.5V12.5H14L14.5 10.5H12.5V9C12.5 8.72 12.72 8.5 13 8.5H13.5Z" fill="#3b5998"/>
      </svg>
    ),
  },
  {
    name: "Instagram",
    desc: "mgmotor.in",
    href: "https://instagram.com/MGMotorIN",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="44" height="44">
        <circle cx="12" cy="12" r="11" stroke="url(#igGrad)" strokeWidth="1.5" fill="white"/>
        <defs>
          <linearGradient id="igGrad" x1="2" y1="22" x2="22" y2="2" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#f9ce34"/>
            <stop offset="40%" stopColor="#ee2a7b"/>
            <stop offset="100%" stopColor="#6228d7"/>
          </linearGradient>
        </defs>
        <rect x="7.5" y="7.5" width="9" height="9" rx="2.5" stroke="url(#igGrad2)" strokeWidth="1.3" fill="none"/>
        <defs>
          <linearGradient id="igGrad2" x1="7.5" y1="16.5" x2="16.5" y2="7.5" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#f9ce34"/>
            <stop offset="40%" stopColor="#ee2a7b"/>
            <stop offset="100%" stopColor="#6228d7"/>
          </linearGradient>
        </defs>
        <circle cx="12" cy="12" r="2.5" stroke="url(#igGrad3)" strokeWidth="1.3" fill="none"/>
        <defs>
          <linearGradient id="igGrad3" x1="9.5" y1="14.5" x2="14.5" y2="9.5" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#f9ce34"/>
            <stop offset="40%" stopColor="#ee2a7b"/>
            <stop offset="100%" stopColor="#6228d7"/>
          </linearGradient>
        </defs>
        <circle cx="15.2" cy="8.8" r="0.6" fill="#ee2a7b"/>
      </svg>
    ),
  },
  {
    name: "Youtube",
    desc: "Morris Garages India",
    href: "https://www.youtube.com/MGMotorIndia",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="44" height="44">
        <circle cx="12" cy="12" r="11" stroke="#ff0000" strokeWidth="1.5" fill="white"/>
        <rect x="6.5" y="8.5" width="11" height="7" rx="2" fill="#ff0000"/>
        <polygon points="10.5,10 10.5,14 14.5,12" fill="white"/>
      </svg>
    ),
  },
  {
    name: "LinkedIn",
    desc: "Morris Garages India",
    href: "https://www.linkedin.com/company/16271169/",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="44" height="44">
        <circle cx="12" cy="12" r="11" stroke="#0077b5" strokeWidth="1.5" fill="white"/>
        <rect x="7" y="10" width="2" height="7" fill="#0077b5"/>
        <circle cx="8" cy="8.5" r="1" fill="#0077b5"/>
        <path d="M11 10h2v1.2C13.3 10.4 14 10 15 10c1.7 0 2.5 1 2.5 3v4h-2v-3.5c0-1-.3-1.5-1-1.5s-1.5.5-1.5 1.5V17h-2V10z" fill="#0077b5"/>
      </svg>
    ),
  },
  {
    name: "Twitter",
    desc: "Morris Garages India",
    href: "https://twitter.com/MGMotorIn",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="44" height="44">
        <circle cx="12" cy="12" r="11" stroke="#1da1f2" strokeWidth="1.5" fill="white"/>
        <path d="M17.5 8.5c-.5.2-1 .4-1.6.4.6-.35 1-.9 1.2-1.6-.55.33-1.16.57-1.8.7A2.8 2.8 0 0 0 10.1 10c0 .22.02.43.07.64-2.33-.12-4.4-1.23-5.78-2.93-.24.41-.38.9-.38 1.4 0 .97.5 1.83 1.25 2.33-.46-.01-.9-.14-1.27-.35v.04c0 1.36.97 2.5 2.25 2.75-.24.07-.49.1-.75.1-.18 0-.36-.02-.53-.05.36 1.12 1.4 1.93 2.63 1.95A5.6 5.6 0 0 1 6 17.13c-.22 0-.43-.01-.64-.04A7.9 7.9 0 0 0 9.67 18c5.2 0 8.05-4.3 8.05-8.03 0-.12 0-.24-.01-.36.55-.4 1.03-.9 1.41-1.47-.51.22-1.05.38-1.62.36z" fill="#1da1f2"/>
      </svg>
    ),
  },
];

const styles = {
  section: {
    background: "#fff",
    padding: "32px 0 36px",
    fontFamily: "'Arial', sans-serif",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 16px",
  },
  row: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "stretch",
  },
  col: {
    flex: "1 1 0",
    minWidth: "120px",
    textAlign: "center",
    padding: "12px 8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
  },
  divider: {
    position: "absolute",
    right: 0,
    top: "10%",
    height: "80%",
    width: "1px",
    background: "#e0e0e0",
  },
  link: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "10px",
    textDecoration: "none",
    transition: "transform 0.2s",
  },
  title: {
    fontSize: "0.97rem",
    fontWeight: "600",
    color: "#222",
    margin: "0 0 4px",
  },
  desc: {
    fontSize: "0.82rem",
    color: "#666",
    margin: 0,
  },
};

export default function MGSocialMedia() {
  const [hovered, setHovered] = React.useState(null);

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <div style={styles.row}>
          {socialLinks.map((item, i) => (
            <div key={item.name} style={styles.col}>
              {i < socialLinks.length - 1 && <div style={styles.divider} />}
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  ...styles.link,
                  transform: hovered === i ? "scale(1.12)" : "scale(1)",
                }}
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(null)}
                aria-label={item.name}
              >
                {item.icon}
              </a>
              <p style={styles.title}>{item.name}</p>
              <p style={styles.desc}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}